import axios from 'axios';

const csrf = document.querySelector("meta[name=csrf-token]");

if ( csrf ){
  axios.defaults.headers.common['X-CSRF-Token'] = csrf.content;
}

export default axios;
